var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "themeStep" } }, [
    _c("div", { staticClass: "theme-step-container" }, [
      _c("div", { staticClass: "theme-body" }, [
        _c(
          "div",
          { staticClass: "mini-stepper" },
          [
            _c("MiniStepper", {
              attrs: { "active-index": _vm.activeIndex, count: 3 },
              on: { changeStep: _vm.changeMiniStepHandler },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.activeIndex === 0
          ? _c("div", { staticClass: "step-1" }, [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("newWizartV2.readytemplate"))),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "themes" },
                _vm._l(_vm.themes, function (theme, index) {
                  return _c(
                    "div",
                    {
                      staticClass: "theme-item",
                      style: { backgroundColor: theme.color },
                      on: {
                        click: function ($event) {
                          return _vm.themeSelectHandler(theme.name)
                        },
                      },
                    },
                    [
                      _vm.selectedTheme === theme.name
                        ? _c("md-icon", [_vm._v("done")])
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "options" }, [
                _c("div", { staticClass: "platforms platforms-container" }, [
                  _c(
                    "div",
                    {
                      staticClass: "platform platform-content",
                      class: { selected: _vm.features === "Instructions" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "fw-header",
                          on: {
                            click: function ($event) {
                              _vm.features =
                                _vm.features === "Instructions"
                                  ? null
                                  : "Instructions"
                            },
                          },
                        },
                        [
                          _c("h4", { staticClass: "title" }, [
                            _vm._v(
                              _vm._s(_vm.$t("newWizartV2.customSettings"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "down-arrow" }, [
                            _vm._v("↓"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.features === "Instructions",
                              expression: "features === 'Instructions'",
                            },
                          ],
                          staticClass: "content",
                        },
                        [
                          _c("div", { staticClass: "customer-balloon" }, [
                            _c("div", { staticClass: "sub-title" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("newWizartV2.customerMessageView")
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "plan" }, [
                              _c("div", { staticClass: "option" }, [
                                _c("div", { staticClass: "option-name" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("newWizartV2.backcgroundColor")
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.customerBubbleColor,
                                      expression: "customerBubbleColor",
                                    },
                                  ],
                                  attrs: { type: "color", id: "c1" },
                                  domProps: { value: _vm.customerBubbleColor },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.customerBubbleColor =
                                        $event.target.value
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "option" }, [
                                _c("div", { staticClass: "option-name" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("newWizartV2.textColor"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.customerTextColor,
                                      expression: "customerTextColor",
                                    },
                                  ],
                                  attrs: { type: "color", id: "c1" },
                                  domProps: { value: _vm.customerTextColor },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.customerTextColor =
                                        $event.target.value
                                    },
                                  },
                                }),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "representative-balloon" }, [
                            _c("div", { staticClass: "sub-title" }, [
                              _vm._v(
                                _vm._s(_vm.$t("newWizartV2.agentMessageView"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "plan" }, [
                              _c("div", { staticClass: "option" }, [
                                _c("div", { staticClass: "option-name" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("newWizartV2.backcgroundColor")
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.representativeBubbleColor,
                                      expression: "representativeBubbleColor",
                                    },
                                  ],
                                  attrs: { type: "color", id: "r1" },
                                  domProps: {
                                    value: _vm.representativeBubbleColor,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.representativeBubbleColor =
                                        $event.target.value
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "option" }, [
                                _c("div", { staticClass: "option-name" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("newWizartV2.textColor"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.representativeTextColor,
                                      expression: "representativeTextColor",
                                    },
                                  ],
                                  attrs: { type: "color", id: "r2" },
                                  domProps: {
                                    value: _vm.representativeTextColor,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.representativeTextColor =
                                        $event.target.value
                                    },
                                  },
                                }),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "next-button",
                              on: { click: _vm.nextButtonClickHandler },
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.$t("fastWizard.continue")) +
                                  "\n                                "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.activeIndex === 1
          ? _c("div", { staticClass: "step-2" }, [
              _c("div", { staticClass: "options" }, [
                _c("div", { staticClass: "customer-balloon" }, [
                  _c("div", { staticClass: "sub-title" }, [
                    _vm._v(_vm._s(_vm.$t("theme.textColor"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "plan" }, [
                    _c("div", { staticClass: "option" }, [
                      _c("div", { staticClass: "option-name" }, [
                        _vm._v(_vm._s(_vm.$t("newWizartV2.textColor"))),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.textColor,
                            expression: "textColor",
                          },
                        ],
                        attrs: { type: "color", id: "c1" },
                        domProps: { value: _vm.textColor },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.textColor = $event.target.value
                          },
                        },
                      }),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "representative-balloon" }, [
                  _c("div", { staticClass: "sub-title" }, [
                    _vm._v(_vm._s(_vm.$t("fastWizard.generalColors"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "plan" }, [
                    _c("div", { staticClass: "option" }, [
                      _c("div", { staticClass: "option-name" }, [
                        _vm._v(_vm._s(_vm.$t("newWizartV2.backcgroundColor"))),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.backgroundColorFirst,
                            expression: "backgroundColorFirst",
                          },
                        ],
                        attrs: { type: "color", id: "r1" },
                        domProps: { value: _vm.backgroundColorFirst },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.backgroundColorFirst = $event.target.value
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "option" }, [
                      _c("div", { staticClass: "option-name" }, [
                        _vm._v(_vm._s(_vm.$t("message.titleColor"))),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.headerColorFirst,
                            expression: "headerColorFirst",
                          },
                        ],
                        attrs: { type: "color", id: "r2" },
                        domProps: { value: _vm.headerColorFirst },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.headerColorFirst = $event.target.value
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "option display" }, [
                      _c("div", { staticClass: "option-name" }, [
                        _vm._v(_vm._s(_vm.$t("message.secondTitleColor"))),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.headerColorSecond,
                            expression: "headerColorSecond",
                          },
                        ],
                        attrs: { type: "color", id: "r2" },
                        domProps: { value: _vm.headerColorSecond },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.headerColorSecond = $event.target.value
                          },
                        },
                      }),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "next-button",
                  on: { click: _vm.nextButtonClickHandler },
                },
                [_vm._v(_vm._s(_vm.$t("newWizartV2.goToNextStep")))]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.activeIndex === 2
          ? _c("div", { staticClass: "step-3" }, [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("fastWizard.selectBubble"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "baloons" }, [
                _c(
                  "span",
                  {
                    on: {
                      click: function () {
                        return _vm.changeBubbleWithIndex("1")
                      },
                    },
                  },
                  [_c("Bubble1")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    on: {
                      click: function () {
                        return _vm.changeBubbleWithIndex("2")
                      },
                    },
                  },
                  [_c("Bubble2")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    on: {
                      click: function () {
                        return _vm.changeBubbleWithIndex("3")
                      },
                    },
                  },
                  [_c("Bubble3")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    on: {
                      click: function () {
                        return _vm.changeBubbleWithIndex("4")
                      },
                    },
                  },
                  [_c("Bubble4")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    on: {
                      click: function () {
                        return _vm.changeBubbleWithIndex("5")
                      },
                    },
                  },
                  [_c("Bubble5")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    on: {
                      click: function () {
                        return _vm.changeBubbleWithIndex("6")
                      },
                    },
                  },
                  [_c("Bubble6")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    on: {
                      click: function () {
                        return _vm.changeBubbleWithIndex("7")
                      },
                    },
                  },
                  [_c("Bubble7")],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sub-title" }, [
                _vm._v(_vm._s(_vm.$t("chatbotv2.chatbotLogo"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "add-logo" }, [
                _c(
                  "div",
                  {
                    staticClass: "upload-button",
                    on: { click: _vm.uploadBubble },
                  },
                  [_vm._v("+")]
                ),
                _vm._v(" "),
                _vm.newIcon ||
                (!!_vm.settings.bubble && !!_vm.settings.bubble.customIcon)
                  ? _c("div", { staticClass: "added-logo" }, [
                      _c("img", {
                        staticStyle: {
                          width: "100px",
                          height: "100px",
                          "object-fit": "contain",
                        },
                        attrs: { src: _vm.bubbleIcon, alt: "bubble" },
                      }),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sub-title" }, [
                _vm._v(_vm._s(_vm.$t("fastWizard.selectChatBubbleColor"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "plan" }, [
                _c("div", { staticClass: "option" }, [
                  _c("div", { staticClass: "option-name" }, [
                    _vm._v(_vm._s(_vm.$t("fastWizard.chatBubbleColor"))),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.bubbleColor,
                        expression: "bubbleColor",
                      },
                    ],
                    attrs: { type: "color", id: "c1" },
                    domProps: { value: _vm.bubbleColor },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.bubbleColor = $event.target.value
                      },
                    },
                  }),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _vm.activeIndex === 0 || _vm.activeIndex === 1
      ? _c("div", { staticClass: "visitor-demo" }, [_c("DemoVisitor")], 1)
      : _c("div", { staticClass: "visitor-demo" }, [_c("live-preview")], 1),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }